@if (formRef) {
  <div [formGroup]="formRef">
    <h3>Primary Reporter</h3>
    @if (isLoadingReporters) {
      <div class="loading-indicator">
        <mat-spinner [diameter]="30"></mat-spinner>
      </div>
    }
    @if (primaryReporter) {
      <mat-form-field>
        <mat-label>Primary Reporter</mat-label>
        <mat-select formControlName="reporter" (selectionChange)="primaryReporterChanged($event)">
          @for (rep of reporters; track rep.Id) {
            <mat-option class="reporter_option" [value]="rep.Id">
              {{ rep.Name | titlecase }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <app-radio-select
        [formRef]="formRef"
        [reporter]="primaryReporter"
        [altContact]="altContact"
        [inlineErrors]="inlineErrors"
        (changeContact)="canSubmit()"
      ></app-radio-select>
    }
  </div>
}